import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import React, { useState, useEffect } from "react";
import PrivateRoute from "./utility/PrivateRoute";
import Login from "./templates/login";
import Dashboard from "./templates/dashboard";
import ExamCategory from "./templates/master/exam-category.js";
import Grade from "./templates/master/grade.js";
import Subject from "./templates/master/subject.js";
import { initAuth } from "./utility/initAuth.js";
import MarksEntry from "./templates/marks-entry.js";
import ExamWiseReport from "./templates/report/exam-wise.js";
import Result from "./templates/report/result.js";
import Criteria from "./templates/master/criteria.js";
import CriteriaEntry from "./templates/criteria-entry.js";

function App() {
  window.addEventListener("error", (e) => {
    if (
      e.message ===
        "ResizeObserver loop completed with undelivered notifications." ||
      e.message === "ResizeObserver loop limit exceeded"
    ) {
      e.stopImmediatePropagation();
    }
  });

  const [authReady, setAuthReady] = useState(false);

  useEffect(() => {
    async function load() {
      await initAuth(); // 🔥 Fetch a new access token at startup
      setAuthReady(true); // Continue app once token loaded
    }
    load();
  }, []);

  return (
    <Router>
      <Routes>
        <Route path="/" element={<Login />} />
        <Route
          path="/dashboard"
          element={
            <PrivateRoute>
              <Dashboard />
            </PrivateRoute>
          }
        />
        <Route
          path="/exam-master"
          element={
            <PrivateRoute>
              <ExamCategory />
            </PrivateRoute>
          }
        />
        <Route
          path="/grade-master"
          element={
            <PrivateRoute>
              <Grade />
            </PrivateRoute>
          }
        />
        <Route
          path="/subject-master"
          element={
            <PrivateRoute>
              <Subject />
            </PrivateRoute>
          }
        />
        <Route
          path="/criteria-master"
          element={
            <PrivateRoute>
              <Criteria />
            </PrivateRoute>
          }
        />
        <Route
          path="/marks-entry"
          element={
            <PrivateRoute>
              <MarksEntry />
            </PrivateRoute>
          }
        />

        <Route
          path="/criteria-entry"
          element={
            <PrivateRoute>
              <CriteriaEntry />
            </PrivateRoute>
          }
        />
        <Route
          path="/exam-wise-report"
          element={
            <PrivateRoute>
              <ExamWiseReport />
            </PrivateRoute>
          }
        />
        <Route
          path="/half-yearly-report"
          element={
            <PrivateRoute>
              <Result Type={"half-yearly"} />
            </PrivateRoute>
          }
        />
        <Route
          path="/annual-report"
          element={
            <PrivateRoute>
              <Result Type={"annual"} />
            </PrivateRoute>
          }
        />
      </Routes>
    </Router>
  );
}

export default App;
